/** JSON-LD structured data — render inside the route component, not in <head>. */
export function JsonLd({ data }: { data: object }) {
  // Escape characters that could break out of the <script> block or be
  // interpreted as HTML. JSON.stringify alone does not escape `<`, `>`, or `&`,
  // so a value like `</script>` in admin-edited content would close the tag
  // early and enable stored XSS.
  const safeJson = JSON.stringify(data)
    .replace(/</g, "\\u003c")
    .replace(/>/g, "\\u003e")
    .replace(/&/g, "\\u0026")
    .replace(/\u2028/g, "\\u2028")
    .replace(/\u2029/g, "\\u2029");
  return (
    <script
      type="application/ld+json"
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: safeJson }}
    />
  );
}
